import { Textarea as ChakraTextarea } from '@chakra-ui/react';
import { forwardRef } from 'react';

type TextareaProps = React.ComponentProps<typeof ChakraTextarea>;

const Textarea = forwardRef<any, TextareaProps>(
  ({ children, ...props }, ref) => {
    return (
      <ChakraTextarea {...props} ref={ref}>
        {children}
      </ChakraTextarea>
    );
  },
);

Textarea.displayName = 'TextArea';

export default Textarea;
